// extracted by mini-css-extract-plugin
module.exports =  {"empty":"empty--_WZAq","video":"video--PhujS","audio":"audio--wR82c"};